
import { BrowserRouter, HashRouter, Outlet } from "react-router-dom";
import { AppRouting } from "./app-routing.component";
import Footer from "./component/home/footer/footer.component";
import { Header } from "./component/home/header/header.component";
import Home from "./component/home/home.component";


function App() {
  return (
    <HashRouter>
      <Header></Header>
      <br></br>
			<br></br>
			<br></br>
      <Outlet></Outlet>
      <AppRouting></AppRouting>
      <Footer></Footer>
    </HashRouter>

  )
}

export default App;
